import { render, staticRenderFns } from "./HIVDiscoveryDataviz.vue?vue&type=template&id=2d3fb3e9&"
import script from "./HIVDiscoveryDataviz.vue?vue&type=script&lang=js&"
export * from "./HIVDiscoveryDataviz.vue?vue&type=script&lang=js&"
import style0 from "./HIVDiscoveryDataviz.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports